import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import {Template} from '../domain/template';
import {TemplateService} from '../core/services/template-service';
import {BreadcrumbService} from '../breadcrumb.service';

@Component({
    templateUrl: './dashboard.component.html'
})
export class DashboardDemoComponent implements OnInit {

    templates: Template[];

    cols: any[];

    chartData: any;

    chartOptions: any;

    selectedTemplate: Template;

    items: MenuItem[];

    constructor(private templateService: TemplateService, private breadcrumbService: BreadcrumbService) {
        this.breadcrumbService.setItems([
            { label: 'Dashboard', routerLink: [''] }
        ]);
    }

    ngOnInit() {
        this.templateService.getTemplates(0, 50, null, 'id,asc').subscribe(data => {
            this.templates = data.content;
        });
    
        this.cols = [
            { field: 'id', header: 'Id' },
            { field: 'iceSupplier', header: 'Ice Supplier' },
            { field: 'content', header: 'Content' },
            { field: 'supplierName', header: 'Name Supplier' },
            { field: 'fiscalId', header: 'Fiscal Id' }
        ];

        this.chartData = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            datasets: [{
                label: 'Sales',
                data: [12, 19, 3, 5, 2, 3, 9],
                borderColor: [
                    '#fd4a85',
                ],
                borderWidth: 3,
                borderDash: [5, 5],
                fill: false,
                pointRadius: 3
            }, {
                label: 'Income',
                data: [1, 2, 5, 3, 12, 7, 15],
                borderColor: [
                    '#12aeee',
                ],
                borderWidth: 3,
                fill: false
            },
                {
                    label: 'Expenses',
                    data: [7, 12, 15, 5, 3, 13, 21],
                    borderColor: [
                        '#a054e5',
                    ],
                    borderWidth: 3,
                    fill: false,
                    pointRadius: [4, 6, 4, 12, 8, 0, 4]
                },
                {
                    label: 'New Users',
                    data: [3, 7, 2, 17, 15, 13, 19],
                    borderColor: [
                        '#f8c336',
                    ],
                    borderWidth: 3,
                    fill: false
                }]
        };

        this.chartOptions = {
            responsive: true,
            hover: {
                mode: 'index'
            }
        };

        this.items = [
            { label: 'Save', icon: 'pi pi-fw pi-check' },
            { label: 'Update', icon: 'pi pi-fw pi-refresh' },
            { label: 'Delete', icon: 'pi pi-fw pi-trash' }
        ];
    }
}
